import { render, staticRenderFns } from "./MemberDirectory.vue?vue&type=template&id=0cfa35f6&scoped=true"
import script from "./MemberDirectory.vue?vue&type=script&lang=js"
export * from "./MemberDirectory.vue?vue&type=script&lang=js"
import style0 from "./MemberDirectory.vue?vue&type=style&index=0&id=0cfa35f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfa35f6",
  null
  
)

export default component.exports